import { Button, Image, Modal } from 'antd';
import { useEffect, useMemo, useRef, useState } from 'react';
import { findChromeBrowserPopup } from '@/utils/findChromeBrowserPopup.ts';
import useUserSettingsStore from '@/store/useUserSettingsStore.ts';
import img3 from '@/public/img/img_3.png';
import useEventCallback from '@/hook/core/useEventCallBack.ts';
const BrowserPluginAlert = () => {
  const [showPluginWarning, setShowPluginWarning] = useState(false);
  const { isInOnboarding } = useUserSettingsStore();
  const popupCounter = useRef(0);
  const handleClose = useEventCallback(() => {
    setShowPluginWarning(false);
  });
  useEffect(() => {
    const timer = setInterval(() => {
      if (findChromeBrowserPopup()) {
        setShowPluginWarning(true);
        clearInterval(timer);
      } else if (popupCounter.current === 10) {
        clearInterval(timer);
      }
      popupCounter.current++;
    }, 500);
    return () => clearInterval(timer);
  }, []);
  const PluginWarningModal = useMemo(
    () => (
      <Modal
        width={600}
        centered
        open={showPluginWarning && !isInOnboarding}
        title={<h2 className="text-red-500">请关闭沉浸式翻译插件</h2>}
        onCancel={handleClose}
        footer={[
          <Button type="primary" danger onClick={handleClose}>
            我知道了
          </Button>,
        ]}>
        <div className="p-4 space-y-3 text-base">
          <p>检测到您开启了沉浸式翻译浏览器插件，这可能会导致：</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>文档无法加载</li>
          </ul>
          <p className="text-gray-500 mt-3">
            请禁用该插件 / 设置禁用翻译网站, 后刷新页面
          </p>
          <p>永不翻译网站添加以下网址：</p>
          <div>
            <p>https://doc2x.com/*</p>
            <p>https://doc2x.noedgeai.com/*</p>
          </div>
          <Image src={img3} className={'w-full'} />
        </div>
      </Modal>
    ),
    [showPluginWarning, isInOnboarding, handleClose],
  );

  return <>{PluginWarningModal}</>;
};

export default BrowserPluginAlert;
